import { useSelector } from 'react-redux'
import { selectReportWidget } from 'redux/selectors/Reports'

import {
  selectIsCreatingWidget,
  selectIsCreatingKpiOption,
  selectWidgetFetchError
} from 'redux/selectors/Widgets'
import { ApplicationState } from 'redux/Stores/types'

export const useIsCreatingWidget = () => {
  return useSelector(selectIsCreatingWidget)
}

export const useIsCreatingKpiOption = () => {
  return useSelector(selectIsCreatingKpiOption)
}

/**
 * Hook for getting fetch error for a specific widget
 * @param widgetId - Widget ID
 * @returns undefined (no error) or error object with status_code
 */
export const useWidgetFetchError = (widgetId: string) => {
  return useSelector((state: ApplicationState) =>
    selectWidgetFetchError(state, widgetId)
  )
}

export const useReportWidget = (id: string) => {
  return useSelector((state: ApplicationState) => selectReportWidget(state, id))
}
